import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        advancedSearch: 'recherche avancée',
        loading: 'chargement',
        morning: 'matin',
        afternoon: 'après midi',
        unitEnum: {
        	d: 'jour',
        	h: 'heure',
        	m: 'minute'
        }
    }
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/core/i18n.js